import Vue from 'vue';
import Vuex from 'vuex';

import auth from "./modules/auth";
import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import users from "./modules/users-module";
import schedule from "./modules/schedule-module";
import order from "./modules/order-module";
import loading from "./modules/loading-module";
import chat from "./modules/chat-module";
import rating from "./modules/rating-module";
import ordertest from "./modules/ordertest-module";
import skills from "./modules/skills-module";
import salary from "./modules/salary-module";
import localization from "./modules/localization-module";
import startBonus from "./modules/bonus-module";
import adminAppConfig from "./modules/adminAppConfig-module";
import postProRetoucher from "./modules/postProRetoucher-module";
import postSeniorRetoucher from "./modules/postSeniorRetoucher-module";
import funcElements from "./modules/func_element-module";
import functionsEdit from "./modules/functions_edit-module";
import holidaySettings from "./modules/admin_calendar_settings-module";
import adminOrdersHistory from "./modules/admin_orders_history-module";
import adminReports from "./modules/admin_reports-module";
import clientAnalytics from "./modules/client_analytics-module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    alerts,
    profile,
    schedule,
    order,
    ordertest,
    users,
    skills,
    salary,
    localization,
    startBonus,
    adminAppConfig,
    postProRetoucher,
    postSeniorRetoucher,
    funcElements,
    functionsEdit,
    holidaySettings,
    adminOrdersHistory,
    rating,
    loading,
    chat,
    adminReports,
    clientAnalytics
  }
});
